<template>
	<div v-if="companyForm" class="py-8">
		<Card>
			<template #content>
				<CompanyPropertiesForm :form="companyForm" @on-save="saveCompany" @on-delete="confirmDelete" :disabled="!$auth.hasPermission('update:companies')"/>
			</template>
		</Card>
	</div>
</template>

<script>
import CompanyPropertiesForm from "@/Forms/Company/CompanyPropertiesForm.vue";
import { mapStores } from "pinia";
import { useCompaniesStore } from "@/stores/companies.js";

export default {
	name: "CompanyPropertiesView",
	components: {CompanyPropertiesForm},
	data() {
		return {
			companyForm: undefined,
		}
	},
	emits: [
		'on-save',
		'on-delete',
	],
	computed: {
		...mapStores(useCompaniesStore)
	},
	methods: {
		async saveCompany() {
			try {
				const response = await this.companyForm.submit();
				this.$emit('on-save');
				this.$router.replace({ params: {...this.$route.params, company: response.data.id} });
			} catch (error) {
				//
			}
		},
		confirmDelete(){
			this.$confirm.require({
				group: 'delete',
				message: this.$t('pages.admin.companies.companies.company.properties.company_properties_view.are_you_sure_you_want_to_delete_this_company'),
				header: this.$t('pages.admin.companies.companies.company.properties.company_properties_view.delete_company'),
				accept: () => {
					this.deleteCompany();
				},
				reject: () => {
					this.$toast.add({
            severity: 'info',
            summary: this.$t('common.cancelled'),
            detail: this.$t('pages.admin.companies.companies.company.properties.company_properties_view.company_was_not_deleted'),
            life: 3000
          });
				}
			});
		},
		async deleteCompany() {
			try {
				if (this.$route.params.company !== 'NEW') {
					await this.companiesStore.deleteCompany(this.$route.params.company);
					this.$emit('on-delete');
				}
				this.$router.push({name: 'admin.companies', params: {...this.$route.params, company: undefined}});
			} catch (error) {
				console.log(error);
			}
		},
	},
	watch: {
		'$route.params.company': {
			async handler(newValue, oldValue) {
				if(newValue){
					if(this.$route.params.company === 'NEW'){
						this.companyForm = await this.companiesStore.createCompany();
					} else {
						this.companyForm = await this.companiesStore.editCompany(this.$route.params.company);
            this.companyForm.id = this.$route.params.company;
					}
				} else {
					this.companyForm = undefined;
				}
			},
			immediate: true,
		}
	},
}
</script>
